import React, { useState } from 'react';
import { Menu, ShoppingCart, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import StarryBackground from './StarryBackground';
import Cart from './Cart';
import WhatsAppButton from './WhatsAppButton';
import SearchBar from './SearchBar';
import WelcomeModal from './WelcomeModal';
import LiveSalesNotification from './LiveSalesNotification';
import { useCartStore } from '../store/cartStore';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(true);
  const totalItems = useCartStore((state) => state.getTotalItems());

  return (
    <div className="min-h-screen bg-black text-white font-rajdhani">
      <StarryBackground>
        {/* Top Header */}
        <header className="fixed top-0 left-0 right-0 h-16 bg-black/50 backdrop-blur-md border-b border-white/10 z-30 px-4 flex items-center justify-between">
          {/* Left: Hamburger */}
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="p-2 text-white hover:text-neon-blue transition-colors rounded-lg hover:bg-white/5"
          >
            <Menu className="w-6 h-6" />
          </button>

          {/* Right: Cart & Phone */}
          <div className="flex items-center gap-4 flex-1 justify-end">
            <div className="hidden md:block w-96 mr-4">
              <SearchBar />
            </div>

            <Link
              to="/contacto"
              className="p-2 text-gray-400 hover:text-neon-purple hover:bg-white/5 rounded-lg transition-all"
            >
              <Phone className="w-5 h-5" />
            </Link>

            <button
              onClick={() => setIsCartOpen(true)}
              className="relative p-2 text-gray-400 hover:text-neon-green hover:bg-white/5 rounded-lg transition-all"
            >
              <ShoppingCart className="w-5 h-5" />
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 bg-neon-green text-black text-xs font-bold w-4 h-4 rounded-full flex items-center justify-center">
                  {totalItems}
                </span>
              )}
            </button>
          </div>
        </header>

        {/* Sidebar Overlay */}
        <Sidebar 
          isOpen={isSidebarOpen} 
          onClose={() => setIsSidebarOpen(false)} 
        />
        
        {/* Cart Drawer */}
        <Cart 
          open={isCartOpen} 
          onClose={() => setIsCartOpen(false)} 
        />
        
        {/* Welcome Modal */}
        <WelcomeModal 
          isOpen={isWelcomeModalOpen}
          onClose={() => setIsWelcomeModalOpen(false)}
        />

        {/* Floating WhatsApp Button */}
        <WhatsAppButton />

        {/* Live Sales Notification */}
        <LiveSalesNotification />

        {/* Main Content */}
        <main 
          className="pt-16 min-h-screen transition-all duration-300 ease-in-out"
        >
          {children}
        </main>
      </StarryBackground>
    </div>
  );
};

export default Layout;
